import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateCompanyMicroDepositsRequestSchema,
  TCreateCompanyMicroDepositsResponseSchema,
} from "./createCompanyMicroDeposits.schema";

export const createCompanyMicroDeposits =
  (axios: IAxiosInstance) =>
  async (body: TCreateCompanyMicroDepositsRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateCompanyMicroDepositsResponseSchema>
    >("/companies/microdeposits/trigger", body);

    return response.data;
  };
